import React, { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import AppBarTeacher from '../form/AppBarTeacher';
import DrawerTeacher from '../form/DrawerTeacher';
import PhotoBox from './PhotoBox';
import InfoBox from './InfoBox';
import HomeworkTablePerTeacher from './HomeworkTablePerTeacher';
import { CopyRight } from '../common/util';
import { useGlobalContext } from '../context/GlobalContext';

const defaultTheme = createTheme();

export default function DashboardTeacher() {
  const { selectedUser } = useGlobalContext();
  const [open, setOpen] = useState(true);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBarTeacher open={open} toggleDrawer={toggleDrawer} />
        <DrawerTeacher open={open} toggleDrawer={toggleDrawer} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8} lg={9}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 240,
                  }}
                >
                  <InfoBox />
                </Paper>
              </Grid>
              <Grid item xs={12} md={4} lg={3}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 240,
                  }}
                >
                  <PhotoBox selectedUser={selectedUser}/>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                  <HomeworkTablePerTeacher />
                </Paper>
              </Grid>
            </Grid>
            {CopyRight()}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}